import { render, staticRenderFns } from "./problemReviewRep.vue?vue&type=template&id=2383980f&"
import script from "./problemReviewRep.vue?vue&type=script&lang=js&"
export * from "./problemReviewRep.vue?vue&type=script&lang=js&"
import style0 from "./problemReviewRep.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports